import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import media from "styled-media-query";
import { theme } from "Helpers/ThemeHelper";
import breakpoints from "Helpers/BreakpointHelper";

let _theme = theme();

export const Ul = styled.ul`
	padding: 0;
	margin: 0;
	li {
		margin-left: 0;
		&:before {
			display: none;
		}
		color: ${({ color }) => (color ? color : "white")};
	}
`;
export const Ol = styled.ol`
	:before {
		display: none;
	}
	li {
		color: ${({ color }) => (color ? color : "white")};
	}
`;
